export class BusinessTransactionWorkQueueDetailModel {
    constructor(data) {
        if (data) {
            this.workQueueId = data.workQueueId;
            this.customerName = data.customerName || '';
            this.customerDOB = data.customerDOB || '';
            this.customerNumber = data.customerNumber;
            this.transactionId = data.transactionId;
            this.transactionType = data.transactionType;
            this.details = data.details;
            this.updatedDate = data.updatedDate;
            this.status = data.status;
            this.statusTypeId = data.statusTypeId;
            this.reason = data.reason;
            this.assignedTo = data.assignedTo;
            this.businessTransactionOverrideId = data.businessTransactionOverrideId;
            this.parentBusinessTransactionWorkQueueId = data.parentBusinessTransactionWorkQueueId;
            this.businessTransactionWorkQueueId = data.businessTransactionWorkQueueId;
            this.assignedUserLoginId = data.assignedUserLoginId;
            this.returnToOriginCSR = data.returnToOriginCSR;
            this.agentName = data.agentName;
            this.agentNumber = data.agentNumber;
            this.elapsedTime = data.elapsedTime;
            this.assignedUserLoginName = data.assignedUserLoginName;
            this.rowSpanString = data.rowSpanString;
            this.appointmentDate = data.appointmentDate;
        }
    }

    agentName: string;
    agentNumber: number;
    appointmentDate: Date;
    assignDropdownValue: number;
    assignedTo: string;
    assignedUserLoginId: number;
    assignedUserLoginName: string;
    businessTransactionOverrideId: number;
    businessTransactionWorkQueueId: string;
    customerDOB: string;
    customerName: string;
    customerNumber: number;
    details: string;
    displaycustomerDOB: string;
    displayUpdatedDate: string;
    displayElapsedTime: string;
    domain: string;
    elapsedTime: string;
    escalationType: string;
    overrideRequestedById: number;
    overrideRequestedByName: string;
    overrideRequestedDateTime: Date;
    parentBusinessTransactionWorkQueueId: string;
    reason: string;
    returnToOriginCSR: boolean;
    rowSpanString: string;
    sourceSystemTypeId: number;
    status: string;
    statusTypeId: number;
    transactionId: string;
    transactionType: string;
    transactionTypeId: number;
    updatedDate: string;
    validationMessage: string;
    workQueueId: number;
}
